"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_WAIVE_CAP_CURRENCIES = exports.PAYMENT_WAIVE_MAX_ABSOLUTE = exports.PAYMENT_WAIVE_MAX_FRACTION = exports.financingPartnerSchema = exports.FINANCING_PARTNERS = void 0;
const zod_1 = require("zod");
// This mirrors Prisma's financing_partner_enum exactly; Rivonia is title-case there too. A drift test keeps the two in sync.
exports.FINANCING_PARTNERS = ['METYCLE', 'CALF', 'SCCF', 'Rivonia', 'YONGGANG'];
exports.financingPartnerSchema = zod_1.z.enum(exports.FINANCING_PARTNERS);
// The payment-conclusion rule on the deal-status payment gate, decided by
// Philip Hoelzer on 2026-08-19: "Mark all BLs concluded with less than 0.5% of
// invoice value (below $500) in outstanding payment && no active claim case
// ongoing."
//
// A per-currency invoice bucket stops blocking 'Complete' when it is fully
// settled, OR when its residual is under BOTH thresholds and the BL carries no
// active claim (claims.status <> 'closed' on a live row — the same definition
// the cash position uses in finance-cash.service.ts). The residual is treated as
// FX movement and bank charges rather than debt.
//
// The absolute cap is applied in the INVOICE CURRENCY with no FX conversion,
// because the buckets are grouped by currency and the gate has never converted.
//
// In today's data the absolute cap is the binding constraint; the fraction is a
// guard for small invoices, where a residual under 500 could still be a large
// share of the invoice (499 on a 1,000 invoice is 49.9% and is refused).
//
// THE RULE IS COMPUTED IN THREE PLACES and they must move together:
//   1. these constants — the TS reimplementations of the gate
//      (orders-bl-level list filter, financing active-deal scan)
//   2. get_bl_deal_statuses(), whose latest definition is
//      backend/prisma/migrations/20260819120000_deal_status_payment_conclusion_rule
//   3. the cached bl_order.status column, written by that function via the
//      update_bl_order_deal_status trigger — so it follows (2) automatically,
//      but only once an event recomputes a given row.
// Setting both to 0 restores the pre-2026-08-19 behaviour exactly.
exports.PAYMENT_WAIVE_MAX_FRACTION = 0.005;
exports.PAYMENT_WAIVE_MAX_ABSOLUTE = 500;
// Two tiers, decided with Philip 2026-08-19. The absolute cap is a currency
// amount, so it only means something in a currency we actually price in:
//   * USD / EUR / GBP  — the residual must clear BOTH the fraction and the cap.
//   * anything else    — the fraction ONLY. A flat 500 is meaningless outside
//     these three (500 INR is about USD 6, so the cap would be absurdly strict
//     rather than protective), and a fraction needs no FX rate because numerator
//     and denominator are already the same currency.
// Same boundary as SUPPORTED_CURRENCIES in
// backend/src/features/data-tape/v2/concentration-cap-engine.service.ts — if that
// set widens, widen this with it.
// A NULL invoice currency is read as USD upstream, so it lands in the capped tier.
exports.PAYMENT_WAIVE_CAP_CURRENCIES = ['USD', 'EUR', 'GBP'];
//# sourceMappingURL=financing.js.map